import React, { useEffect } from "react";
import { useSelector } from "react-redux";
// import Modal from "react-modal";
// import CommonTable from "../../../common-components/common-tables/CommonTable";
// import LiveSubsLogCards from "../../mobile-view/LiveSubsLogCards";
// import { convertThenFormat } from "../../../common-data/Converts";
// import {
//   CalendarIcon,
//   CallIcon,
//   ExcludeIcon,
//   PersonArmsUpIcon,
//   PersonIcon,
//   PersonStandingIcon,
// } from "../../../../images/icons/icons";
// import TrainerMemberMap from "../../../trainer-member-engagement/trainer-member-map/TrainerMemberMap";
// import DetailModHeader from "../../../common-components/DetailModHeader";
import LiveTbCols from "../../LiveTbCols";

const LiveSubsLogs = ({
  isPage,
  setIsPage,
  pageLimit,
  setPageLimit,
  allDatas,
  setAllDatas,
  userInfoData,
  callFunction,
}) => {
  const { liveSubsLogs, liveSubsLogsError, liveSubsLogsLoading } = useSelector(
    (state) => state.live
  );

  // const iniModValues = {
  //   isModOpen: false,
  //   modName: "",
  //   rowData: "",
  // };
  // const [modValues, setModValues] = useState(iniModValues);

  // const onCloseModal = () => {
  //   setModValues(iniModValues);
  // };

  useEffect(() => {
    if (
      !liveSubsLogsLoading &&
      !liveSubsLogsError &&
      liveSubsLogs?.status &&
      liveSubsLogs?.data
    ) {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: liveSubsLogs.data,
        pagination:
          liveSubsLogs?.pagination?.length > 0 ? liveSubsLogs.pagination : [],
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allData: [],
        pagination: [],
      }));
    }
  }, [liveSubsLogsLoading, liveSubsLogsError, liveSubsLogs]);

  // const tbColumns = [
  //   {
  //     dataField: "name",
  //     text: "member info",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <PersonIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.name || "NA"}</span>{" "}
  //           </div>

  //           <div className="tb-flex">
  //             <span className="tb-data tb-info-icon">
  //               <CallIcon />
  //             </span>{" "}
  //             <span className="tb-data">{row?.mobile || "NA"}</span>{" "}
  //           </div>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "gym_name",
  //     text: "Gym Name",
  //     formatter: (_, row) => {
  //       return <span className="tb-data">{row?.gym_name || "NA"}</span>;
  //     },
  //   },
  //   {
  //     dataField: "type",
  //     text: "plan type",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             {row?.type === "regular" ? (
  //               <PersonStandingIcon color="#2c3e50" />
  //             ) : (
  //               <PersonArmsUpIcon color="#2c3e50" />
  //             )}
  //           </span>{" "}
  //           <span className="tb-data">
  //             {row?.type?.replace(/_/g, " ") || "-"}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "plan_name",
  //     text: "plan name",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex-col">
  //           <span className="tb-data">{row?.plan_name || "NA"}</span>
  //           <span className="tb-data">
  //             @ ₹{convertThenFormat(row?.price || 0)}
  //           </span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "purchase_date",
  //     text: "Purchase date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">{row?.purchase_date || "-"}</span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "start_date",
  //     text: "start date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">{row?.start_date || "-"}</span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "expire_date",
  //     text: "expire date",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="tb-flex">
  //           <span className="tb-data tb-info-icon">
  //             <CalendarIcon color="#2c3e50" />
  //           </span>{" "}
  //           <span className="tb-data">{row?.expire_date || "-"}</span>
  //         </div>
  //       );
  //     },
  //   },
  //   {
  //     dataField: "actions",
  //     text: "Actions",
  //     formatter: (_, row) => {
  //       return (
  //         <div className="pp-employee-payroll-actions">
  //           <button
  //             key="map-trainer"
  //             type="button"
  //             className="pp-employee-payroll-action-button pp-outlined-border"
  //             onClick={() =>
  //               setModValues((prevs) => ({
  //                 ...prevs,
  //                 isModOpen: true,
  //                 modName: "trainer_member_map",
  //                 rowData: row,
  //               }))
  //             }
  //           >
  //             <ExcludeIcon />
  //             map trainer
  //           </button>
  //         </div>
  //       );
  //     },
  //   },
  // ];

  return (
    <>
      <LiveTbCols
        from="new_subscription"
        userInfoData={userInfoData}
        allDatas={allDatas}
        isPage={isPage}
        setIsPage={setIsPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        callFunction={callFunction}
        isLoading={liveSubsLogsLoading}
      />

      {/* <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Edit Modal"
        ariaHideApp={false}
      >
        <div className={`createNewCTOModalContainer mod-width-50p`}>
          <DetailModHeader
            info={modValues.rowData}
            onClose={onCloseModal}
            isOnlySubscription={true}
          />

          {modValues.modName === "trainer_member_map" ? (
            <TrainerMemberMap
              userInfoData={userInfoData}
              rowData={modValues.rowData}
              closeModal={onCloseModal}
              callFunction={callFunction}
            />
          ) : null}
        </div>
      </Modal>

      <div className="common-table-container mt15">
        <CommonTable
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          tableColumns={tbColumns}
          isPage={isPage}
          setIsPage={setIsPage}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
          isLoading={liveSubsLogsLoading}
        />
      </div> */}

      {/* <div className="only-mobile">
        <LiveSubsLogCards
          tableData={allDatas.allData}
          tablePagination={allDatas.pagination}
          isPage={isPage}
          setIsPage={setIsPage}
        />
      </div> */}
    </>
  );
};

export default LiveSubsLogs;
